import React from 'react';
import Svg from '../Svg';

const IconThermometer02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 4.5C8.5 2.567 10.067 1 12 1C13.933 1 15.5 2.567 15.5 4.5V13.2572C16.72 14.2649 17.5 15.7912 17.5 17.5C17.5 20.5376 15.0376 23 12 23C8.96243 23 6.5 20.5376 6.5 17.5C6.5 15.7912 7.27997 14.2649 8.5 13.2572V4.5ZM12 3C11.1716 3 10.5 3.67157 10.5 4.5V13.7578C10.5 14.0915 10.3336 14.4032 10.0563 14.5888C9.11575 15.2183 8.5 16.2875 8.5 17.5C8.5 19.433 10.067 21 12 21C13.933 21 15.5 19.433 15.5 17.5C15.5 16.2875 14.8842 15.2183 13.9437 14.5888C13.6664 14.4032 13.5 14.0915 13.5 13.7578V4.5C13.5 3.67157 12.8284 3 12 3ZM10 17.5C10 16.3954 10.8954 15.5 12 15.5C13.1046 15.5 14 16.3954 14 17.5C14 18.6046 13.1046 19.5 12 19.5C10.8954 19.5 10 18.6046 10 17.5Z"
    />
  </Svg>
);

export default IconThermometer02;
